import { useMutation as r } from "@tanstack/react-query";
import { a as e } from "./api.DHdhNbok.js";
import { saveTimestampToLocalStorage as a } from "../utils/storage/index.js";
var t = /* @__PURE__ */ ((s) => (s[s.ProxyStart = 13] = "ProxyStart", s[s.ProxyEnd = 14] = "ProxyEnd", s[s.EmulationEnd = 10] = "EmulationEnd", s[s.TermsAndConditionsAccepted = 57] = "TermsAndConditionsAccepted", s))(t || {});
const u = {
  publish: "/api/events/message/publish"
}, m = async (s) => {
  a();
  const o = await e.post(u.publish, s);
  if (!o.ok) {
    const n = await o.json();
    throw new Error(n);
  }
  return o.json();
}, p = (s) => r({
  ...s,
  mutationFn: m
});
export {
  t as A,
  p as u
};
